export default "/images/SL_droite.png?56ae7c1385bc6dc4a612939980ea7ec3";